import React from "react";
import styled, { css } from "styled-components";

// #region SCOPED CSS
// A natural line box fits inside the bordered control; flex owns vertical and horizontal centering.
export const premiumButtonLabelAlignment = css`
    box-sizing: border-box; display: flex; align-items: center; justify-content: center; line-height: normal;
`;

// Visual reference: Header.jsx centre-button rules. Layout spacing belongs to the parent.
const Button = styled.button`
    ${premiumButtonLabelAlignment}
    width: 120px; min-width: 120px; height: 35px; padding: 0; margin: 0;
    background: linear-gradient(180deg, #252729, #1a1c1e);
    border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 6px;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035);
    color: var(--text-icons-gray-100, #d1d1d1); font-family: "Roboto", sans-serif;
    font-size: 12px; font-weight: 500; letter-spacing: 0.35px; text-transform: uppercase;
    text-align: center; cursor: pointer;
    transition: background-color 140ms ease, border-color 140ms ease, box-shadow 140ms ease;
    &:enabled:hover {
        background: linear-gradient(180deg, #302c25, #211f1b);
        border-color: rgba(239, 191, 115, 0.55);
    }
    /* Pressed buttons retain the reference's normal/hover treatment. */
    &:focus-visible { outline: 2px solid #efbf73; outline-offset: -3px; }
    &:disabled {
        background: #1a1c1e; border-color: rgba(255, 255, 255, 0.07);
        color: var(--text-icons-gray-300, #4f5b6d); box-shadow: none; cursor: not-allowed;
    }
`;
// #endregion

/**
 * Application-neutral Main Header button presentation.
 * label: ReactNode; disabled?: boolean; busy?: boolean; onClick?(event); className?;
 * type?: "button" | "submit" | "reset" (defaults to "button"). Busy disables activation.
 * The parent owns availability and behaviour; there are no requests or navigation effects.
 */
export default function PremiumHeaderButton({ label, disabled = false, busy = false, onClick,
    className, type = "button" }) {
    const unavailable = disabled || busy;
    return <Button className={className} type={type} disabled={unavailable} aria-busy={busy || undefined}
        onClick={event => { if (!unavailable) onClick?.(event); }}>{label}</Button>;
}
